import React from 'react';
import Modal from '../modal/Modal';
import { getClassNames } from '../../tools/helpers';

/**
 * A confirmation step that states a consequence.
 *
 * It deliberately never asks "are you sure?" — a question an operator answers
 * yes to by reflex, having read nothing. The body says what stops happening,
 * which is the only thing that makes the pause worth anything.
 *
 * The scrim, the box and the centring are Modal's; everything here is the copy
 * and the two buttons.
 *
 * @param {Object} props
 * @param {string} props.title - What is about to happen, as a question.
 * @param {string} props.body - The consequence, in full.
 * @param {string} props.confirmLabel - The action, named. Never "OK".
 * @param {string} [props.tone] - "danger" for anything that stops runs.
 * @param {boolean} [props.pending] - While the request is in flight.
 * @param {React.RefObject<HTMLElement>} [props.contentRef] - The page's content column,
 *   so the dialog centres on it rather than on the window.
 * @param {function(): void} props.onConfirm
 * @param {function(): void} props.onCancel
 * @returns {JSX.Element}
 */
export default function ConfirmModal({
  title, body, confirmLabel, tone, pending, contentRef, onConfirm, onCancel,
}) {
  return (
    <Modal
      title={title}
      className="gmpro-modal"
      contentRef={contentRef}
      testId="gmpro-confirm-modal"
    >
      <p className="gmpro-modal__body">{body}</p>

      <div className="gmpro-modal__actions">
        <button
          type="button"
          className="gmpro-modal__cancel"
          onClick={onCancel}
          disabled={pending}
        >
          Cancel
        </button>
        <button
          type="button"
          className={getClassNames('gmpro-modal__confirm', {danger: tone === 'danger'})}
          onClick={onConfirm}
          disabled={pending}
          data-testid="gmpro-confirm-accept"
        >
          {pending ? 'Working…' : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
